import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { log } from 'util';
@Component({
  selector: 'app-error-status-dialog',
  templateUrl: './error-status-dialog.component.html',
  styleUrls: ['./error-status-dialog.component.scss']
})
export class ErrorStatusDialogComponent implements OnInit {
  emailId = [];
  phoneNumber = [];
  fullName = [];
  permanentPinCode = [];
  currentPinCode = [];
  qualification = [];
  gender = [];
  duplicatePhoneNumber = [];
  invalidColumn = [];
  invalidCityEmail = [];
  invalidUserKeyEmail=[];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    // console.log('register all list-->',this.data.response.data.registerAll);

    console.log('data-->', this.data.errorFor);
    console.log('response-->', this.data.response)
    if (this.data.errorFor === 'row') {
      this.valueAssignInArray();
      console.log('phone number-->', this.phoneNumber);
    } else if (this.data.errorFor === 'cityUpdate') {
      console.log(this.data.response.data.emailIdList);
      if (this.data.response.data.emailIdList.length > 0) {
        this.invalidCityEmail.push(this.data.response.data.emailIdList);
      }
    }
    else if(this.data.errorFor ==='emailUserKey'){
      if(this.data.response.data.errorList.length>0){
        this.invalidUserKeyEmail.push(this.data.response.data.errorList)
      }   
    }
    else {


      this.invalidColumn = this.data.response;
      console.log('column invalid', this.invalidColumn);

    }

    //  this.valueAssignInArray();
  }

  valueAssignInArray() {
    for (let i = 0; i < this.data.response.data.registerAll.length; i++) {
      console.log('i--->', this.data.response.data.registerAll[i].phoneNumber);

      if (this.data.response.data.registerAll[i].emailId != null) {
        this.emailId.push(this.data.response.data.registerAll[i].emailId);
      }
      if (this.data.response.data.registerAll[i].fullName != null) {
        this.fullName.push(this.data.response.data.registerAll[i].fullName);
      }
      if (this.data.response.data.registerAll[i].permanentPinCode != null) {
        this.permanentPinCode.push(this.data.response.data.registerAll[i].permanentPinCode);
      }
      if (this.data.response.data.registerAll[i].currentPinCode != null) {
        this.currentPinCode.push(this.data.response.data.registerAll[i].currentPinCode);
      }
      if (this.data.response.data.registerAll[i].phoneNumber != null) {
        this.phoneNumber.push(this.data.response.data.registerAll[i].phoneNumber);
      }
      if (this.data.response.data.registerAll[i].qualification != null) {
        this.qualification.push(this.data.response.data.registerAll[i].qualification);
      }
      if (this.data.response.data.registerAll[i].gender != null) {
        this.gender.push(this.data.response.data.registerAll[i].gender);
      }
      if (this.data.response.data.registerAll[i].duplicatePhoneNumber != null) {
        this.duplicatePhoneNumber.push(this.data.response.data.registerAll[i].duplicatePhoneNumber);

      }
      console.log(this.phoneNumber.length)
    }


  }
}
